import * as React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const HeatMapComponent = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={600}>
      <ComposedChart
        layout="vertical"
        data={data}
        margin={{
          top: 20, right: 20, bottom: 20, left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis type="number" scale="sqrt" />
        <YAxis dataKey="time" type="category" />
        <Tooltip />
        <Legend />
        <Bar dataKey="creates" fill="#04c44e" barSize={40} />
          <Bar dataKey="reads" fill="#e6e212" barSize={20} />
          <Bar dataKey="updates" fill="#443dd9" barSize={20} />
          <Bar dataKey="deletes" fill="#f7b934" barSize={20} />
        <Bar dataKey="alerts" fill="#de3309" barSize={20} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default HeatMapComponent;
